/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 16.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import DataProvider from "../../../DataProvider";
import DataWidget from "../DataWidget";
import DataTable from "../../../pages/Resource/DataTable/DataTable";
import ViewTuple from "./ViewTuple";

/**
 * Show specified array rows together in one line.
 * Specify in UI Schema as follows:
 *  {
 *      "ui:widget": "list",
 *      "ui:options": {
 *          "listClass": listClassName,
 *          "joinExpr": [joinExpr, ...],
 *          "fields": [field, ...]
 *      }
 *  }
 *
 */
class ViewList extends React.Component {
    static propTypes = {
        dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
        field: PropTypes.string.isRequired
    };

    static defaultProps = {
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    renderItems() {
        /**
         * @type {DataProvider}
         */
        let dataProvider = this.props.dataProvider.getProvider(this.props.field);

        let rows = dataProvider.getRowCount();
        let items = [];
        for (let i = 0; i < rows; i++) {
            let childDataProvider = dataProvider.getProvider(i);
            items.push((<li key={i}><ViewTuple dataProvider={childDataProvider} field={null} /></li>));
        }
        return items;
    }

    render() {
        let dataProvider = this.props.dataProvider.getProvider(this.props.field);
        let schema = dataProvider.getSchema();
        let options = schema.getSchemaElement("options");
        let listClass = null;
        if (options && options.listClass) listClass = options.listClass;

        return (
            <ul className={listClass}>
                {this.renderItems()}
            </ul>
        );
    }
}

export default ViewList;
